export const errorBoundary = {
  title: 'Sorry~ 页面崩溃了😩'
}

export default errorBoundary